import React, { useRef, useState, useEffect, useId } from 'react';
import { Popup } from 'reactjs-popup';
import cx from 'classnames';
import styles from './index.module.scss.js';

function useStableClass(prefix = "blk") {
  const reactId = useId();
  const once = useRef();
  if (!once.current) {
    const safe = reactId.replace(/[:]/g, "");
    once.current = `${prefix}-${safe}`;
  }
  return once.current;
}
const BasePopup = ({
  className,
  style,
  anchor,
  children,
  kind = "primary",
  spacing = "medium",
  onActive,
  isActive,
  showEvent = "click",
  refPopup,
  position,
  isCenter = true,
  setIsActive,
  setHeight,
  ...props
}) => {
  const anchorRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState();
  const [popupPosition, setPopupPosition] = useState("bottom");
  const cls = useStableClass("card");
  const updatePosition = () => {
    if (!anchorRef.current) return;
    const rect = anchorRef.current.getBoundingClientRect();
    const HEADER_HEIGHT = 80;
    const spaceBottom = window.innerHeight - rect.bottom - HEADER_HEIGHT;
    const spaceTop = rect.top - HEADER_HEIGHT;
    let newMaxHeight;
    let newPopupPosition;
    if (spaceBottom > 150) {
      newPopupPosition = "bottom";
      newMaxHeight = spaceBottom - 20;
    } else if (spaceTop > 150) {
      newPopupPosition = "top";
      newMaxHeight = spaceTop - 20;
    } else {
      newPopupPosition = spaceBottom > spaceTop ? "bottom" : "top";
      newMaxHeight = Math.max(spaceBottom, spaceTop) - 20;
    }
    setPopupPosition(newPopupPosition);
    setMaxHeight(newMaxHeight);
    if (setHeight) setHeight(newMaxHeight);
    requestAnimationFrame(() => {
      const popupEl = document.querySelector(`.${cls}-content`);
      if (!popupEl) return;
      const popupRect = popupEl.getBoundingClientRect();
      let shiftX = 0;
      if (popupRect.right > window.screen.width) {
        shiftX = window.screen.width - popupRect.right - 10;
      }
      if (popupRect.left < 0) {
        shiftX = -popupRect.left + 10;
      }
      popupEl.style.transform = `translateX(${shiftX}px)`;
    });
  };
  const lockScroll = () => {
    updatePosition();
    document.body.style.overflow = "hidden";
    setIsActive && setIsActive(true);
  };
  const unlockScroll = () => {
    document.body.style.overflow = "";
    setIsActive && setIsActive(false);
  };
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return /* @__PURE__ */ React.createElement("div", { ref: anchorRef, onMouseDown: () => lockScroll(), className: "my-test123" }, /* @__PURE__ */ React.createElement(
    Popup,
    {
      ref: refPopup,
      contentStyle: { zIndex: 99999 },
      overlayStyle: { zIndex: 999989 },
      className: cls,
      trigger: /* @__PURE__ */ React.createElement("div", null, anchor),
      position: isCenter ? "bottom center" : popupPosition === "bottom" ? "bottom right" : "top right",
      keepTooltipInside: false,
      repositionOnResize: false,
      onClose: () => unlockScroll(),
      open: isActive
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.box__inner, style: { maxHeight, overflowY: "auto" } }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.box, className, {
          [styles[kind]]: !!kind,
          [styles[spacing]]: !!spacing
        }),
        style
      },
      children
    ))
  ));
};
BasePopup.displayName = "Popup.BasePopup";

export { BasePopup };
//# sourceMappingURL=index.js.map
